import React, { Component } from "react";
import { Row, Col, Container, Form, Button, Table, Image, Card } from "react-bootstrap";
import axios, { post } from "axios";
import GatePassModal from "./gatePassModal";
import Camera from "../studentAdmission/camera"
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import moment, { invalid } from "moment";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import "./_gatePass.scss"
import dummiImage from "../../../images/businessman.png"
import jsPDF from "jspdf";

const ADD_INANDOUT_DETAILS = gql`
  mutation($params: AddPermissionDetails) {
    addInAndOutStatus(params: $params)
  }`

class GatePassSection extends Component {
    constructor(props) {
        super();
        this.state = {
            rollno_mobile: "",
            rollno_mobile_error: "",
            student_details: [],
            dataError: "",
            loading: 0,
            camera: false,
            cameraFileOpen: "",
            inOutReceiverLogoFilePath: "",
            inOutReceiverImagePreviewUrl: "",
            inOutReceiverLogoFilePath: "",
            file: "",
            selectedOptionId: "1",
            submitted: false,
            submitError: "",
            isCardVisible: true,
            showDownloadButton: false,
            beforeSubmitted: false,
            currentDateandTime: new Date(),
            reqDate: "",
            reqDate_error: "",
            requested_date_array: []
        }
    }
    fileUpload(file, stream) {
        console.log("fileupload", file, stream);
        const url = "https://rizee.in/mobile1.php?uploadInOrOutImage=true";
        const formData = new FormData();
        formData.append("file", file);
        formData.append("stream", stream);
        const config = {
            headers: {
                "content-type": "application/x-www-form-urlencoded",
            },
        };

        return post(url, formData, config);
    }

    parenthandleinputchange = async (e) => {
        let reader = new FileReader();

        let file = {
            lastModified: "1683974399048",
            name: "testing.jpeg",
            size: "99768",
            type: "image/jpeg",
            webkitRelativePath: "",
            filename: "testing.jpeg",
            mimetype: "image/jpeg",

        }

        let fobj = {
            stream: e,
            filename: "testing.jpeg",
            mimetype: "image/jpeg",
        };


        const upload = await this.fileUpload(file, fobj.stream);

        console.log("upload", upload.data);

        if (upload.data.result == "success") {

            this.setState({
                inOutReceiverLogoFilePath: upload.data.filename,
                inOutReceiverImagePreviewUrl: e,
            });
        }
    }

    handleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "rollno_mobile") {

            let requested_date_array = []
            if (value !== "") {
                if (this.props.getParentsPermissionDetails.filter((i) => (i.permission_status == 1).length > 0)) {
                    requested_date_array = this.props.getParentsPermissionDetails.filter((item) => item.roll_no == value || item.student_mobile == value)
                }
                console.log("dates", requested_date_array);
            }
            this.setState({
                rollno_mobile: value,
                rollno_mobile_error: "",
                dataError: "",
                student_details: [],
                loading: 0,
                showDownloadButton: false,
                inOutReceiverLogoFilePath: "",
                inOutReceiverImagePreviewUrl: "",
                inOutReceiverLogoFilePath: "",
                beforeSubmitted: false,
                reqDate: "",
                requested_date_array: requested_date_array

            })
        }
        if (name == "radioOption") {
            this.setState({
                selectedOptionId: e.target.id,
                student_details: [],
                rollno_mobile: "",
                showDownloadButton: false,
                inOutReceiverLogoFilePath: "",
                inOutReceiverImagePreviewUrl: "",
                inOutReceiverLogoFilePath: "",
                reqDate: "",
                beforeSubmitted: false
            })
        }
        if (name == "reqDate") {
            this.setState({
                reqDate: value,
                reqDate_error: "",
                student_details: [],
                showDownloadButton: false,
                inOutReceiverLogoFilePath: "",
                inOutReceiverImagePreviewUrl: "",
                inOutReceiverLogoFilePath: "",
            })
        }


    }

    getApprovedStudent = () => {
        if (this.state.rollno_mobile == "") {
            this.setState({
                rollno_mobile_error: "Please Enter Roll No",
                loading: 0
            })
            return ""
        }
        if (this.state.reqDate == "") {
            this.setState({
                reqDate_error: "Please select Date",
                loading: 0
            })
            return ""
        }
        this.setState({
            loading: 1
        })

        if (this.props.getParentsPermissionDetails.filter((i) => (i.permission_status == 1).length > 0)) {
            var filterData = this.props.getParentsPermissionDetails.filter((item) => (item.roll_no == this.state.rollno_mobile || item.student_mobile == this.state.rollno_mobile) && moment.unix(item.from_datetime).format("DD-MM-YYYY") == this.state.reqDate)
            console.log("filterdata", filterData);
            if (filterData.length > 0) {
                if ((filterData[0].outtime == "" || filterData[0].outtime == null) && this.state.selectedOptionId == "1") {
                    console.log("btnnnn1");
                    this.setState({
                        student_details: filterData,
                        loading: 0
                    })
                    console.log("kk", filterData.outtime_image_path == "" && this.state.selectedOptionId == "1");
                } else if ((filterData[0].intime == "" || filterData[0].intime == null) && this.state.selectedOptionId == "2") {
                    console.log("btnnnn2");

                    this.setState({
                        student_details: filterData,
                        loading: 0
                    })
                } else {
                    console.log("btnnnn3");
                    this.setState({ showDownloadButton: true, loading: 0, beforeSubmitted: true })
                }

            } else {
                this.setState({ dataError: "No Data Found", loading: 0, student_details: [] })

            }
        } else {
            this.setState({ dataError: "No Data Found", loading: 0, student_details: [] })

        }

    }

    handleImageSubmit = () => {
        let inTimeImagePath = ""
        if (this.state.selectedOptionId == 2 && this.state.inOutReceiverLogoFilePath != "") {
            inTimeImagePath = `https://rizee.in/educational_mngt/permissions/${this.state.inOutReceiverLogoFilePath}`

        }
        let outTimeImagePath = ""
        if (this.state.selectedOptionId == 1 && this.state.inOutReceiverLogoFilePath != "") {
            outTimeImagePath = `https://rizee.in/educational_mngt/permissions/${this.state.inOutReceiverLogoFilePath}`
        }
        const params = {
            inOrOut_id: parseInt(this.state.selectedOptionId),
            outtime_image_path: outTimeImagePath,
            intime_image_path: inTimeImagePath,
            permission_id: this.state.student_details[0].permission_id
        }



        this.setState({
            loading: 2
        });

        this.addInAndOutDetails(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log("params", params);
            console.log(error);


            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loading: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        setTimeout(() => {
            this.SetpageLoad()
        }, 3000)
        this.handleDownload()
    }

    addInAndOutDetails = async (
        params) => {
        await this.props.addInAndOutDetails({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addInAndOutStatus) {
                    this.setState({
                        loading: 0,
                        submitted: true
                    })

                }
            }

        });

    };
    SetpageLoad = () => {
        this.setState({ submitted: false, submitError: "", loading: 0 });
        window.location.reload(false);
    };

    handleDownload = () => {

        if (this.props.getParentsPermissionDetails.filter((i) => i.outtime != "" && i.outtime != null)) {

            console.log("dataaaa", this.props.getParentsPermissionDetails.filter((item1) => {
                console.log("item1", item1);
            }));
            var filter_data = this.props.getParentsPermissionDetails.filter((item) => (item.roll_no == this.state.rollno_mobile || item.student_mobile == this.state.rollno_mobile) && (moment.unix(item.from_datetime).format("DD-MM-YYYY") == this.state.reqDate))
        }

        console.log("dd", filter_data);

        const logo = this.props.getOrganisationProfile.logo
        console.log("logo",);
        const address = this.props.getOrganisationProfile.complete_address
        const image = `https://admin.rizee.in/files/${logo}`
        const collegeName = this.props.getOrganisationProfile.organisation_name

        const doc = new jsPDF();
        doc.rect(15, 15, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 182);

        let capturReceiverImage = "";
        let outDate = "";
        let outTime = "";
        let message = ""

        if (this.state.beforeSubmitted) {
            if (this.state.selectedOptionId == 1) {
                capturReceiverImage = `${filter_data[0].outtime_image_path}`;
                outDate = moment.unix(filter_data[0].outtime).format("DD-MM-YYYY");
                outTime = moment.unix(filter_data[0].outtime).format(" HH:mm:ss");
                message = "out";
            } else {
                capturReceiverImage = `${filter_data[0].intime_image_path}`;
                outDate = moment.unix(filter_data[0].intime).format("DD-MM-YYYY");
                outTime = moment.unix(filter_data[0].intime).format(" HH:mm:ss");
                message = "In"
            }
        } else {
            if (this.state.inOutReceiverLogoFilePath != "") {

                // debugger;
                let date = this.state.currentDateandTime;
                console.log("date", date);
                let day = date.getDate();
                let month = date.getMonth() + 1;
                let year = date.getFullYear();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let seconds = date.getSeconds();

                outDate = `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
                outTime = `${hours}:${minutes}:${seconds}`;

                capturReceiverImage = `https://rizee.in/educational_mngt/permissions/${this.state.inOutReceiverLogoFilePath}`;
                if (this.state.selectedOptionId == 1) {
                    message = "Out"
                } else {
                    message = "In"
                }

            }
        }

        let sName = ""
        let sRoll = ""
        let recieverName = ""

        if (filter_data[0].student_name != "" && filter_data[0].student_name != null) {
            sName = filter_data[0].student_name
        } else {
            sName = "--"
        }

        if (filter_data[0].roll_no != "" && filter_data[0].roll_no != null) {
            sRoll = filter_data[0].roll_no
        } else {
            sRoll = "--"
        }

        if (filter_data[0].receiver_name != "" && filter_data[0].receiver_name != null) {
            recieverName = filter_data[0].receiver_name
        } else {
            recieverName = "--"
        }

        const msg = `${message}Time Receiver Image:`
        const recieverImage = `${filter_data[0].receiver_image_path}`
        const signatureX = 150;
        const signatureY = 120
        const signatureFontSize = 12;
        const signatureUnderlineX = signatureX;
        const signatureUnderlineY = signatureY + 7;
        const signatureUnderlineWidth = doc.getStringUnitWidth("Authorized Sign") + 38;
        const signatureUnderlineHeight = 0.2;

        doc.setFontSize(signatureFontSize);
        doc.text("Authorized Sign", signatureX, signatureY);


        doc.setLineWidth(signatureUnderlineHeight);
        doc.line(signatureUnderlineX, signatureUnderlineY, signatureUnderlineX + signatureUnderlineWidth, signatureUnderlineY);



        const imgData = image
        const imgWidth = 28;
        const imgHeight = 17;
        doc.addImage(imgData, 'JPEG', 25, 20, imgWidth, imgHeight);
        const adressSize = 11
        doc.setFontSize(adressSize)
        doc.text(address, 58, 31)
        const imgWidth1 = 25;
        const imgHeight1 = 29;
        doc.addImage(recieverImage, 'JPEG', 35, 88, imgWidth1, imgHeight1);
        doc.addImage(capturReceiverImage, 'JPEG', 79, 88, imgWidth1, imgHeight1);
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(13);
        doc.text(`Student Name:`, 25, 60);
        doc.text(`Student RollNo:`, 25, 68);
        doc.text(`Reciever Name:`, 25, 76);
        doc.text(`Reciever Image:`, 25, 84);
        doc.text(`Date:`, 150, 52);
        doc.text(`Time:`, 150, 58);
        doc.text(msg, 68, 85)

        const studentName = sName;
        const studentRoll = sRoll;
        const RecieverName = recieverName
        const Date = `${outDate.toString()}`
        const Time = `${outTime.toString()}`
        doc.setFont('Helvetica', 'none');
        doc.setFontSize(14);
        doc.text(studentName, 65, 60);
        doc.text(studentRoll, 65, 68);
        doc.text(RecieverName, 65, 76);
        doc.text(Date, 165, 52);
        doc.text(Time, 165, 58);



        const headingX = 74;
        const headingY = 49;
        const headingFontSize = 15;
        const underlineX = headingX;
        const underlineY = headingY + 2;
        const underlineWidth = doc.getStringUnitWidth("STUDENT PASS") + 35;
        const underlineHeight = 0.5;

        doc.setFont(undefined, 'bold');
        doc.setFontSize(headingFontSize);
        doc.text("STUDENT PASS", headingX, headingY);


        doc.setLineWidth(underlineHeight);
        doc.line(underlineX, underlineY, underlineX + underlineWidth, underlineY);
        const collegeSize = 17;
        doc.setFontSize(collegeSize)
        doc.text(collegeName, 58, 25)
        doc.save(`${filter_data[0].roll_no}.pdf`);
    }

    render() {



        let date = new Date();

        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();

        let outDate = `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
        let outTime = `${hours}:${minutes}:${seconds}`;

        console.log("tiiiiii", outDate, outTime);

        console.log("devi", this.state, this.props);
        const logo = this.props.getOrganisationProfile.logo
        return (
            <Container className="">
                <Row className="mt-3">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">STUDENT GATE PASS</h2>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <Row>
                            <Col className="d-flex mb-3 ft_size"  >
                                <Form.Check type="radio" name="radioOption" id="1" label="OUT" className="mr-3" onChange={this.handleInputChange} checked={this.state.selectedOptionId === '1'} />
                                <Form.Check type="radio" name="radioOption" onChange={this.handleInputChange} id="2" label="IN" />
                            </Col>
                        </Row>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                    <Form.Label className="text-uppercase font-weight-bold">RollNo/Mobile</Form.Label>
                                    <Form.Control as="input" name="rollno_mobile" onChange={this.handleInputChange} placeholder="Enter Your RollNo/Mobile" value={this.state.rollno_mobile}>
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.rollno_mobile_error}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase font-weight-bold">Select Request Date</Form.Label>
                                    <Form.Control as="select" name="reqDate" onChange={this.handleInputChange} value={this.state.reqDate}>
                                        <option value="">--Select--</option>
                                        {this.state.requested_date_array.map((item) => (
                                            <option >
                                                {moment.unix(item.from_datetime).format("DD-MM-YYYY")}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.reqDate_error}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                    <Button className="text-uppercase getStudent_btn mt-30" onClick={(e) => this.getApprovedStudent()}>Get Student</Button>

                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12}>
                                    {
                                        this.state.showDownloadButton == true ?
                                            (<Button className="btn btn-success download_button text-uppercase" block onClick={this.handleDownload}>Download Pass</Button>) : ""
                                    }

                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col>

                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="text-center">
                        <span className="text-center text-danger mt-3">{this.state.dataError}</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {
                            this.state.loading == 1 ? (
                                <span className="spinner-border spinner-border-sm text-center spinner-alignment"></span>
                            ) : ""
                        }

                    </Col>
                </Row>
                {
                    this.state.student_details.length > 0 ?
                        <Card className="student_content">
                            <Card.Body className="ml-5">
                                <Row className="mt-1">
                                    <Col lg={6} md={12} sm={12}>
                                        {
                                            (this.state.student_details[0].receiver_image_path != null && this.state.student_details[0].receiver_image_path != "") ?
                                                <img src={this.state.student_details[0].receiver_image_path} alt="" width={130} height={150} />
                                                : (
                                                    <img src={dummiImage} alt="" width={130} height={150} />
                                                )
                                        }

                                        <div className="mt-3">
                                            <p className="mt-2">Student Name : <span className="ml-2 student_details">{this.state.student_details[0].student_name}</span></p>
                                            <p className="mt-2">Roll Number : <span className="ml-2 student_details">{this.state.student_details[0].roll_no}</span></p>
                                            {(this.state.student_details[0].receiver_name != null && this.state.student_details[0].receiver_name != "") ?
                                            <p className="mt-2">Reciever Name : <span className="ml-2 student_details">{this.state.student_details[0].receiver_name}</span></p>
                                            : (
                                                <p className="mt-2">Reciever Name :<span className="ml-2 student_details">--</span></p>
                                            )
                                        }
                                        {(this.state.student_details[0].receiver_mobile != null && this.state.student_details[0].receiver_mobile != "") ?
                                            <p className="mt-2">Reciever Mobile : <span className="ml-2 student_details">{this.state.student_details[0].receiver_mobile}</span></p>
                                            : (
                                                <p className="mt-2">Reciever Mobile : <span className="ml-2 student_details">--</span></p>
                                            )
                                        }
                                        </div>
                                    </Col>
                                    <Col lg={6} md={12} sm={12} className="imagesizes imageUploads">

                                        <Button onClick={() => this.setState({ camera: true })} className="upload_btns btn_position">Capture image</Button>
                                        {
                                            this.state.inOutReceiverImagePreviewUrl ? (
                                                <Image src={`${this.state.inOutReceiverImagePreviewUrl}`} style={{ width: '155px', height: "27vh", marginTop: "-290px", marginRight: "250px" }} className='upload_btns btn_position' />

                                            ) : (
                                                <p className='samplePhotos'>Upload Image</p>
                                            )
                                        }
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col className="text-center">
                                        <Button className="btn btn-primary submitting_btn" onClick={this.handleImageSubmit}>
                                            {
                                                this.state.loading == 2 ? (
                                                    <span className="spinner-border spinner-border-sm "></span>
                                                ) : ""
                                            }
                                            SUBMIT</Button>
                                        <div>
                                            {
                                                this.state.submitted == true ? (
                                                    <p className="text-success mt-1 text-center" >Status Submitted </p>
                                                ) : ""
                                            }
                                            {
                                                this.state.submitError != "" ? (
                                                    <span className="text-danger mt-1">{this.state.submitError}</span>
                                                ) : ("")
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        : ""
                }
                <Camera
                    stateData={this.state}
                    show={this.state.camera}
                    parenthandleinputchange={this.parenthandleinputchange}
                    onHide={() => this.setState({ camera: false })}
                />
            </Container>
        )
    }
}
export default withRouter(compose(
    graphql(ADD_INANDOUT_DETAILS, {
        name: "addInAndOutDetails"
    })

)(GatePassSection));
